module.exports = __webpack_public_path__ + "img/video409.c0601d20.jpg";